import React from 'react'
import { Route, Routes } from 'react-router-dom'
import NotFoundPage from '../pages/404/NotFoundPage'
import {Container} from 'react-bootstrap'
import MenuAdministrative from '../components/menus/menu-administrative'
import Dashboard from '../pages/administrative/Dashboard'
import Reports from '../pages/administrative/Reports'
import Invoices from '../pages/administrative/Invoices'
// import Cards from '../pages/administrative/card/Cards'
import Cardsaux from '../pages/administrative/card/Cardsaux'
import CardEdit from '../pages/administrative/card/CardEdit'
import Cards from '../pages/administrative/signup/Cards'

export default function AdministrativeRouter () {   
    return (
        <Container className='cabecera'>
            <MenuAdministrative/>
            <Routes>
                <Route path="/dashboard" element={<Dashboard/>}/>
                <Route path="/reports" element={<Reports/>}/>
                <Route path="/invoices" element={<Invoices/>}/>
                <Route path="/cards" element={<Cards/>}/>
                <Route path="/cardschange" element={<Cardsaux/>}/>
                <Route exact path="/card/:id" element={<CardEdit/>}/>
                <Route path="*" element={<NotFoundPage />}/>
            </Routes>
        </Container>
    )
}